import PropTypes from 'prop-types';
import { useInView } from 'react-intersection-observer';
import { makeStyles } from '@material-ui/styles';
import classNames from 'classnames';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

import BlockLayout from 'Blocks/BlockLayout';
import Typography from 'Components/Typography';

const useStyles = makeStyles(
  {
    appear: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
      transition: 'opacity 300ms ease-in',
    },
  },
  { name: 'Softfooter' }
);

const Softfooter = ({ content }) => {
  const classes = useStyles();
  // side-effects to lazy-load the background image
  const [blockRef, blockInView] = useInView({
    triggerOnce: true,
  });

  // side-effect to fade-in the text
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });

  const appearAnimation = classNames(classes.appear, { [classes.visible]: inView === true });

  return (
    <BlockLayout
      ref={blockRef}
      backgroundImage={blockInView ? content.image : undefined}
      contentAlign="center"
    >
      <Typography ref={ref} color="white" markupName="h2" paragraph variant="h1">
        <span className={appearAnimation}>{content.title}</span>
      </Typography>
    </BlockLayout>
  );
};

Softfooter.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    image: srcOrNextImageProp.isRequired,
  }).isRequired,
};

export default Softfooter;
